import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);
export default new Vuetify({                         
  theme: {
    options: { customProperties: true},
    theme: {
      themes: {
        light: {
          primary: '#3f51b5',
          secondary: '#b0bec5',
          anchor: '#8c9eff',
        },
        dark: {
          primary: 'blue',
          secondary: '#b0bec5',
          anchor: '#8c9eff',
        },
      },
    },
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },

})